import { CodeIcon } from '@mm/icons';
import classnames from 'classnames';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';
import {
  generateAttributeStructure,
  nameById,
} from '@mm/state/helpers/filterable-select-helpers';
import FilterableSelect from '../FilterableSelect/FilterableSelect';
import './AttributePicker.scss';
import AttributeModel from '@mm/state/model/AttributeModel';
import { hiddenVariables } from '@mm/state/helpers/variable-names-helper';

type Props = {
  onAttributePicked: (attribute: string) => any;
  className?: string;
  classNameForIcon?: string;
  perLine?: number;
  showOnlyNameAttributes?: boolean;
  color?: string;
};

const AttributePicker: React.FC<Props> = props => {
  const {
    className,
    onAttributePicked,
    classNameForIcon,
    showOnlyNameAttributes = false,
    color,
    children,
  } = props;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const attributes =
    useSelector((state: StoreState) => state.attribute.entities) || [];
  const filteredAttributes = attributes?.filter(
    attr => !hiddenVariables.includes(attr.name.toLocaleLowerCase()),
  );
  const fbPageName =
    useSelector((state: StoreState) => state.connectedPage.pageDetails?.name) ||
    'Page';

  const classList = classnames('attribute-picker', className, {
    'attribute-picker--dropdown-open': dropdownOpen,
  });
  const iconClassList = classnames(
    'attribute-picker__icon',
    'fas',
    'fa-code',
    classNameForIcon,
  );

  const renderSuggestion = (suggestion: AttributeModel) => (
    <span style={{ textTransform: 'capitalize' }}>
      {suggestion?.friendlyName || suggestion.name}
    </span>
  );

  return (
    <div className={classList}>
      {!children && (
        <CodeIcon
          color={color}
          className={classNameForIcon}
          onClick={() => setDropdownOpen(true)}
        />
      )}
      {children && (
        <span onClick={() => setDropdownOpen(true)}>{children}</span>
      )}

      {dropdownOpen && (
        <FilterableSelect
          showSuggestOnly={true}
          className="attribute-picker__dropdown"
          onBlur={() => setDropdownOpen(false)}
          onChange={id => {
            setDropdownOpen(false);
            onAttributePicked(nameById(id, attributes, '', true));
          }}
          searchPlaceholder="Select an attribute"
          suggestions={
            filteredAttributes &&
            generateAttributeStructure(
              filteredAttributes,
              fbPageName,
              showOnlyNameAttributes,
            )
          }
          suggestionRenderer={renderSuggestion}
        />
      )}
    </div>
  );
};

export default AttributePicker;
